import * as React from 'react';

import style from './index.css';
import { IHighway } from 'shared/types/geo/direction';
import { Button } from '../button';

export interface IHighwayProps {
  highway: IHighway;
  selected: boolean;

  deselectHighways(highwaysIds: number[]): void;
  selectHighways(highwaysIds: number[]): void;
}

export class Highway extends React.Component<IHighwayProps> {
  public render() {
    const { selected, highway } = this.props;

    return (
      <div className={style['highway']} onClick={this.handleClick}>
        {selected ? (
          <Button theme="primary" className={style['button']}>
            {highway.fullName}
          </Button>
        ) : (
          <span className={style['highway-title']}>{highway.fullName}</span>
        )}
      </div>
    );
  }

  private handleClick = () => {
    const { deselectHighways, highway, selected, selectHighways } = this.props;

    if (selected) {
      return deselectHighways([highway.id]);
    }

    selectHighways([highway.id]);
  };
}
